var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo text-center"},[_c('img',{staticClass:"logo-image",attrs:{"src":(_vm.publicPath + "logo.svg")}}),_c('div',{staticClass:"logo-name text-white mt-4"},[_vm._v("\n    "+_vm._s(_vm.serverName)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }